var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNova(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ba3892d2-cdba-479a-9a53-e9bdb94ead81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-387ab2a5-39a6-4e1e-8b04-4ef52e2395e7{fill:#fff;}.uuid-167bd284-2ed7-4967-a693-b81f1507439e{fill:url(#uuid-44bd669d-f493-4921-b398-be891b87d12f);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-44bd669d-f493-4921-b398-be891b87d12f",
    x1: 449.77,
    y1: 3032.31,
    x2: 57.05,
    y2: 2691.9,
    gradientTransform: "translate(0 3120.35) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6732"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-167bd284-2ed7-4967-a693-b81f1507439e",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-387ab2a5-39a6-4e1e-8b04-4ef52e2395e7",
    d: "m109.43,274.32c0,16.4,2.66,32.06,7.6,46.81l26.29-8.24c-21.22-62.26,12.05-129.92,74.31-151.14,62.26-21.22,129.92,12.05,151.14,74.31,8.52,25,8.49,52.12-.09,77.1l26.29,7.88c25.73-76.75-15.62-159.83-92.37-185.56-76.75-25.73-159.83,15.62-185.56,92.37-5.02,14.98-7.59,30.67-7.6,46.47Zm-27.48,82.45c28.67-15.39,103.7-46.08,173.87-45.8s145.38,30.69,174.24,45.8c-31.15-7.7-109.56-22.9-174.24-22.9-67.97,0-142.91,14.93-173.87,22.9Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNova);
export default __webpack_public_path__ + "static/media/icon_nova.733e200102220aa07e1ffce7040495b8.svg";
export { ForwardRef as ReactComponent };